<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import { ShiftCMSState } from '@/store';
import { Notification } from '@/models/notification.model';

const store = useStore<ShiftCMSState>();

const showNotification = computed<boolean>(
  () => store.getters.showNotification,
);
const notifications = computed<Notification[]>(() => store.state.notifications);
</script>
<template>
  <div class="alerts">
    <v-alert
      class="mt-4"
      v-model="showNotification"
      density="compact"
      elevation="4"
      v-for="n in notifications"
      :type="n.type"
      :key="n.message"
    >
      {{ n.message }}
    </v-alert>
  </div>
</template>
<style scoped>
.alerts {
  position: fixed;
  bottom: 16px;
  z-index: 300;
  right: 16px;
  width: 400px;
}
</style>
